export type TransactionStateDTO =
  (typeof TransactionStateDTO)[keyof typeof TransactionStateDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionStateDTO = {
  captured: 'captured',
  refunded: 'refunded',
} as const;
